<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="delete()">DELETE</button>
  <button mat-raised-button (click)="cancel()">CANCEL</button>
</mat-dialog-actions>

